// extracted by mini-css-extract-plugin
export var animationContainer = "_mj-0";
export var footer = "_mj-1";
export var gray = "_mj-2";
export var lineItem = "_mj-3";
export var lineItemImage = "_mj-4";
export var lineItemInfo = "_mj-5";
export var lineItemText = "_mj-6";
export var lineItems = "_mj-7";
export var modalContent = "_mj-8";
export var options = "_mj-9";
export var orderName = "_mj-a";
export var refundAmount = "_mj-b";